import { useEffect, useState } from 'react';
import { SingleSelectButtonGroup, TextField, Stack, Text } from '@stitch-fix/mode-react';
import { LookFeedbackFreeformTextQuestion, LookFeedbackMultipleChoiceQuestion } from '../../../../../types/definitions/vendor/graphql-schema.d';
export type FeedbackQuestion = LookFeedbackFreeformTextQuestion | LookFeedbackMultipleChoiceQuestion;
export type FeedbackFormProps = {
  feedbackQuestions: FeedbackQuestion[];
  onChange: (questionId: string, answer: string) => void;
};
const DEBOUNCE_MS = 500;
const FreeformTextQuestion = ({
  question,
  onChange
}: {
  question: LookFeedbackFreeformTextQuestion;
  onChange: (questionId: string, answer: string) => void;
}) => {
  const [value, setValue] = useState(question.answer ?? '');
  useEffect(() => {
    const handler = setTimeout(() => {
      if (value !== question.answer) {
        onChange(question.questionId, value);
      }
    }, DEBOUNCE_MS);
    return () => clearTimeout(handler);
  }, [value, question.answer, question.questionId, onChange]);
  return <Stack spacing={0.5} key={question.id}>
      <Text setting="title-xxsmall">{question.label}</Text>
      <TextField key={question.id} label={question.label} name={question.id} placeholder={question.placeholderText ?? ''} value={value} onChange={setValue} rows={4} hideLabel />
    </Stack>;
};
const FeedbackForm = ({
  feedbackQuestions,
  onChange
}: FeedbackFormProps) => <Stack spacing={1}>
    {feedbackQuestions.map(question => {
    switch (question.__typename) {
      case 'LookFeedbackFreeformTextQuestion':
        return <FreeformTextQuestion key={question.id} question={question} onChange={onChange} />;
      case 'LookFeedbackMultipleChoiceQuestion':
        {
          const optionMinWidth = Math.min(100 / question.options.length, 100);
          return <Stack spacing={0.5} key={question.id}>
              <Text setting="title-xxsmall">{question.label}</Text>
              <SingleSelectButtonGroup optionMinWidth={`${optionMinWidth}%`} name={question.id} options={question.options} direction="horizontal" spacing="grouped" value={question.answer ?? ''} onChange={value => onChange(question.questionId, value)} />
            </Stack>;
        }
      default:
        return null;
    }
  })}
  </Stack>;
export default FeedbackForm;